<template>
  <div>
    <v-layout wrap justify-center pt-10>
      <v-flex xs12 >
        <v-layout wrap pa-3  justify-center style="background-color: #3d673a;">
          <h2 class="text-center mb-4 mt-3" style="font-weight: bold;color:white;font-family:poppinsbold;font-size:27px">Frequently Asked Questions</h2>
          <v-flex xs12 sm11 md11 lg11 pb-8>
            <v-expansion-panels accordion>
              <v-expansion-panel
                v-for="(faq, index) in faqs"
                :key="index"
                class="mb-3"
                style="border-radius: 20px;  border: 2px solid white;overflow: hidden; background-color: #3d673a; color: black;"
              >
                <v-expansion-panel-header style="font-weight: bold;color:white;font-family:poppinsbold" disable-icon-rotate>
                  {{ faq.question }}
                  <template v-slot:actions>
                    <v-icon size="30px" color="green"  class="circle-icon">mdi-chevron-down</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="faq-content" v-html="faq.answer"></div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  data() {
    return {
      faqs: [
        { question: "What is the difference between Wildlife Conservation and Wildlife Sciences?", 
        answer: "Wildlife Conservation focuses on the practical application of knowledge to protect, manage, and restore wildlife species and their habitats. It emphasises policy, community engagement, and strategies to address human-wildlife conflicts, habitat degradation, and biodiversity loss. Conservation efforts often integrate social, economic, and ecological aspects to achieve sustainable outcomes.On the other hand, Wildlife Sciences is a broader field that delves into the scientific study and understanding of wildlife. It encompasses research on animal biology, behaviour, ecology, genetics, and population dynamics. This field provides the foundational knowledge that informs conservation strategies. In essence, Wildlife Sciences generates knowledge, while Wildlife Conservation applies that knowledge to address real-world challenges." },
        { question: "What is the duration of the M.Sc. in Wildlife Conservation Action program?", 
        answer: "The program spans two years, divided into four semesters." },
        { question: "Who is eligible for the program?", 
        answer: "Applicants should have a bachelor's degree in any science subject such as Botany, Zoology, Chemistry, Physics, Statistics, Geography, Geology, Life Sciences, Environmental Sciences, Microbiology, Biotechnology, Fisheries, Marine Biology, Horticulture, Agriculture, Computer Science, Data Science, Veterinary Science, Health Sciences, or any branch of Engineering. Relevant social science subjects and management studies are also considered. A minimum of 50% aggregate marks at the undergraduate level is required (45% for SC/ST/OBC candidates). Candidates with degrees in other subjects should have a minimum of three years of work experience in conservation, supported by a certificate from the relevant organisation." },
        
        {
    question: "What is the structure of the program?",
    answer: `
    <p style="margin-bottom: 10px;">The curriculum integrates wildlife sciences with social issues in managing and mitigating wildlife conflict and natural resource management. It includes coursework, intensive fieldwork, and internships, covering topics like ecosystem studies, biodiversity assessment, wildlife health, rescue and rehabilitation, and legal instruments for wildlife conservation.</p>

      <p style="margin-bottom: 10px;">The M.Sc. in Wildlife Conservation Action at Bharati Vidyapeeth University is a two-year postgraduate program structured over four semesters, requiring a minimum of 104 credits for completion.</p>
      <p style="margin-bottom: 10px;"><strong>Semester-wise Course Structure:</strong></p>
      <ul style="list-style-type: disc;">
        <li><strong>Semester I:</strong>
          <ul style="list-style-type: circle;">
            <li><strong>Core Theory Courses:</strong>
              <ul style="list-style-type: square;">
                <li>Wildlife Law and Trade Control (3 credits)</li>
                <li>Conservation Problems and Practices (3 credits)</li>
                <li>Ecosystem Studies (3 credits)</li>
                <li>Fundamentals of Geospatial Science and Technology (3 credits)</li>
              </ul>
            </li>
            <li><strong>Core Practical Courses:</strong>
              <ul style="list-style-type: square;">
                <li>Field Techniques I (1 credit)</li>
                <li>Field Taxonomy I (1 credit)</li>
                <li>Geospatial Techniques (1 credit)</li>
              </ul>
            </li>
            <li><strong>General Courses:</strong>
              <ul style="list-style-type: square;">
                <li>Statistical Methods (2 credits)</li>
                <li>Research Methodology (2 credits)</li>
              </ul>
            </li>
            <li><strong>Total Credits:</strong> 19</li>
          </ul>
        </li>
        <li><strong>Semester II:</strong>
          <ul style="list-style-type: circle;">
            <li><strong>Core Theory Courses:</strong>
              <ul style="list-style-type: square;">
                <li>Biodiversity Assessment and Conservation (3 credits)</li>
                <li>Wildlife Health, Rescue, and Rehabilitation (3 credits)</li>
                <li>Behavioral Ecology (3 credits)</li>
              </ul>
            </li>
            <li><strong>Core Practical Courses:</strong>
              <ul style="list-style-type: square;">
                <li>Field Taxonomy II (1 credit)</li>
                <li>Field Techniques II (1 credit)</li>
                <li>Data Analysis with R (1 credit)</li>
                <li>Field Work (2 credits)</li>
                <li>Internship (2 credits)</li>
              </ul>
            </li>
            <li><strong>Elective Courses (Choose any two):</strong>
              <ul style="list-style-type: square;">
                <li>Urban Biodiversity (3 credits)</li>
                <li>SWAYAM Elective (3 credits)</li>
                <li>Climate Change Science and Strategies (3 credits)</li>
                <li>Natural Resource Management (3 credits)</li>
                <li>Eco-restoration (3 credits)</li>
              </ul>
            </li>
            <li><strong>General Courses:</strong>
              <ul style="list-style-type: square;">
                <li>Academic and Research Report Writing (2 credits)</li>
                <li>General English (2 credits)</li>
              </ul>
            </li>
            <li><strong>Total Credits:</strong> 22</li>
          </ul>
        </li>
        <!-- Add Semester III and IV similar to this -->
      </ul>

          <p style="margin-bottom: 10px;">This comprehensive structure integrates core theoretical knowledge, practical field experience, elective specializations, and research components to prepare students for effective careers in wildlife conservation. </p>

    `
  },


        
        { question: "Does the institute have International Collaboration?",
         answer: "Yes, the institute is in collaboration with the University of Cologne, Germany; through DAAD scholarship, we conduct exchange programs across the country." },
        { question: "What career opportunities are available after completing this course?", 
        answer: "Graduates can explore diverse career opportunities as wildlife researchers, managers, and conservationists. They can contribute to government and non-governmental organisations like the Wildlife Trust of India, World Wide Fund for Nature, ATREE, WII, and IUCN. Additionally, they can work with industries and municipal corporations as biodiversity officers, assist banks in biodiversity evaluation, or join various national and international foundations dedicated to conservation efforts." },
        { question: "Does the program offer practical training?", 
        answer: "Yes, the program includes practical training through fieldwork, internships, and research projects, providing hands-on experience in wildlife conservation." },
        { question: "What are the program outcomes?", 
        answer: "Students will gain comprehensive knowledge in biodiversity conservation and management, wildlife rescue and rehabilitation, and legal aspects of wildlife conservation. The program also builds skills in conducting research and communicating for wildlife conservation." },
     
        { question: "Is there an entrance exam and how are the students selected?", 
        answer: "Students are selected based on the Interview and submission of their Resume and Statement of purpose." },
      ],
    };
  },
};
</script>

<style>
.text-center {
  text-align: center;
}
.circle-icon {
  background-color: #ffcf59; /* Change to your desired color */
  border-radius: 50%;
  padding: 0px; /* Adjust size */
  color: white; /* Arrow color */
}
.faq-content {
  color: white;
  text-align: left;
  font-size: 16px;
  line-height: 1.5;
}

.faq-content ul {
  list-style-type: disc;
 
}

.faq-content ul ul {
  list-style-type: circle;
}

.faq-content ul ul ul {
  list-style-type: square;
}

</style>